module.exports = __webpack_public_path__ + "static/media/page-redeemInfo.64914f1b.jpg";